module.exports = __webpack_public_path__ + "img/portrait-083.078a92bd.jpg";